<input
    #elementRef
    [attr.type]="inputType$ | async"
    [formControl]="numberControl"
    [id]="id"
    [lang]="language"
    class="sh-input-field sh-form-group__input"
    [required]="required"
    [attr.step]="step"
    [attr.min]="min"
    [attr.max]="max"
    [attr.placeholder]="message$ | async"
    [attr.aria-describedBy]="invalid ? describeLabelId : null"
    [attr.aria-invalid]="invalid"
    [attr.disabled]="disabled ? true : null"
    (focus)="focusChange($event)"
    (blur)="focusChange($event)"
    (keyup)="keyboardChange($event)"
/>
